<div class="modal-header d-flex justify-content-center bg-light">
    <h4 class="modal-title text-center strong">Place bid<div>
            <div class="row">
                <div [ngClass]="InitialActive == true ? 'OrangeClass' : 'GreyClass'" class="col btn-next-month small">
                    Material #{{InitialValue}}</div>

                <div [ngClass]="FinalActive == true ? 'OrangeClass' : 'GreyClass'" class="col btn-next-month small">
                    Material #{{FinalValue}}</div>
            </div>
            <div class="avisible-lg position-relative">
                <div class="line1">
                    <img class="bg-secondary" src="/images/Div.svg" width="50%" alt="">
                    <div class="ellipse">
                        <img src="/images/Ellipse 18.svg" alt="" *ngIf="InitialActive">
                        <img src="/images/Ellipse 19_grey.svg" alt="" *ngIf="FinalActive">
                    </div>

                    <div class="ellipse-new position-absolute">
                        <img src="/images/Ellipse 18.svg" alt="" *ngIf="FinalActive">
                        <img src="/images/Ellipse 19_grey.svg" alt="" *ngIf="InitialActive">
                    </div>

                </div>
            </div>
        </div>
    </h4>
</div>
<div class="modal-body bg-light">
    <div class="center">
        <!-- <div class="small text-secondary  small">Material #</div> -->
        <h5 class="strong mb-2">
            {{productInfo.newName?productInfo.newName:productInfo.productName}}</h5>
        <div class="small text-secondary  mt-2"
            *ngIf="(code.commodityType=='CC' || code.commodityType=='IO') && code?.arrivalPeriod == 'true'">
            {{'tenders.ArrivalPeriod'| cxTranslate}}</div>
        <div class="small text-secondary "
            *ngIf="(code.commodityType=='CC' || code.commodityType=='IO') && code?.arrivalPeriod == 'false'">
            {{'tenders.LoadPortLaycan'| cxTranslate}}</div>
            <div class="small text-secondary "
            *ngIf="(code.commodityType=='CA') && code?.arrivalPeriod == 'false'">
            {{'tenders.schedule'| cxTranslate}}</div>
        <div class="small text-secondary mt-2" *ngIf="code.commodityType =='CN'">
            {{'tenders.Deliveryperiod'| cxTranslate}}
        </div>
        <div class="small" *ngIf=" code?.arrivalPeriod == 'false'">{{productInfo && productInfo.laycanStartDate |
            date:"dd/MM/yyyy"}} -
            {{productInfo && productInfo.laycanEndDate | date:"dd/MM/yyyy"}}</div>
        <div class="small" *ngIf=" code?.arrivalPeriod == 'true'">{{code && code.arrivalStartDate | date:"dd/MM/yyyy"}}
            -
            {{code && code.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
        <div class="small text-secondary mt-2" *ngIf="code.commodityType=='IO'&& productInfo?.feBasis">
            {{'tenders.feBasis'|
            cxTranslate}}</div>
        <div class="small" *ngIf="code.commodityType=='IO'&& productInfo?.feBasis">{{productInfo?.feBasis}}%
        </div>
        <div class="small text-secondary mt-2"
            *ngIf="productInfo?.pricingOptionsEnum.length==1 &&  productInfo?.minimumQuantity && productInfo?.maximumQuantity">
            {{ 'tenders.Quantity(DMT)' | cxTranslate }} ({{productInfo.displayQuantityUnitDesc}})</div>
        <div class="small"
            *ngIf="productInfo ?.pricingOptionsEnum.length==1 &&  productInfo?.minimumQuantity && productInfo?.maximumQuantity">
            {{productInfo.minimumQuantity }} - {{productInfo.maximumQuantity}}</div>

    </div>

    <div class="mt-4 mb-4">
        <!--coal specific-->
        <div class="small">
            <h6 *ngIf="productInfo.quantity" class="strong">{{ 'tenders.Quantity(DMT)' | cxTranslate }}
                ({{productInfo.displayQuantityUnitDesc}})
            </h6>
            <h6 *ngIf="productInfo.minimumQuantity && productInfo.maximumQuantity " class="strong">Select {{
                'tenders.Quantity(DMT)' | cxTranslate }} ({{productInfo.displayQuantityUnitDesc}})
            </h6>
            <h5 class="strong"
                *ngIf="productInfo.quantity  && !productInfo.minimumQuantity && !productInfo.maximumQuantity && productInfo.isQuantityUnrestricted== false">
                {{productInfo.quantity | number}}</h5>
            <input type="number" min="0" max="999999" [(ngModel)]="productInfo.quantityshw" class="form-control"
                *ngIf="productInfo.quantity && productInfo.isQuantityUnrestricted== true">
            <div
                *ngIf="productInfo.pricingOptionsEnum?.length>=1 &&  productInfo?.minimumQuantity && productInfo?.maximumQuantity">
                <div>
                    <button class="btn btn-secondary btn-lg custom-button left"
                        [disabled]="value===productInfo.minimumQuantity" (click)="changeQuantity('decrease',5000)"><i
                            class="fa fa-minus" aria-hidden="true"></i></button>
                    <input type="number" class="form-control-lg custom-input" [(ngModel)]="value" disabled>
                    <button class="btn btn-secondary btn-lg custom-button right"
                        [disabled]="value===productInfo.maximumQuantity" (click)="changeQuantity('increase',5000)"><i
                            class="fa fa-plus" aria-hidden="true"></i></button>
                </div>

                <p *ngIf="value===productInfo.maximumQuantity" class="text-primary my-1 md-semibold-font "> Maximum
                    quantity selected.</p>
                <p *ngIf="value===productInfo.minimumQuantity" class="text-primary my-1 md-semibold-font "> Minimum
                    quantity selected.</p>

                <!-- <h5 class="strong" *ngIf="productInfo.pricingOptionsEnum?.length>=1 ">{{value}}</h5>
                <input type="range" class="form-range w-100" [min]="productInfo?.minimumQuantity"
                    [max]="productInfo?.maximumQuantity" step="5000" [(ngModel)]="value"> -->
            </div>
        </div>
    </div>
    <div class="form-group" *ngIf=" productInfo.isDischargePortUnrestricted== true">
        <h6 class="strong">{{ 'tenders.DischargePort' | cxTranslate }}</h6>
        <!-- <h5 class="strong" *ngIf=" productInfo?.dischargePortDetails && productInfo.isDischargePortUnrestricted== false">{{productInfo?.dischargePortDetails}}</h5> -->
        <input type="text" [(ngModel)]="productInfo.dischargePortshw" class="form-control">
    </div>
    <!-- <div class="form-group" *ngIf="code.commodityType =='CC' && productInfo.pricingOptionsEnum?.length>1 && productInfo?.maximumQuantity && productInfo?.maximumQuantity">
        <input type="text" [(ngModel)]="quantity" 
            class="form-control form-control-lg" #name="ngModel" required />
        <p *ngIf="quantity>productInfo.maximumQuantity" class="text-danger my-1 md-semibold-font "> Maximum
            acceptable quantity is {{productInfo.maximumQuantity | number}}</p>
        <p *ngIf="quantity<productInfo.minimumQuantity" class="text-danger my-1 md-semibold-font "> Minimum
            acceptable quantity is {{productInfo.minimumQuantity | number}}</p>
    </div> -->
    <div *ngIf="productInfo?.pricingOptionsEnum?.length==1 ">
        <div *ngFor="let options of productInfo.pricingOptionsEnum">
            <div *ngIf="productInfo.pricingBasis[0] && options.pricingOptions!='FIXED_PRICE'" class="form-group">
                <div *ngIf="code.commodityType!='CA'" class="small text-secondary">{{'tenders.Pricingbasis' | cxTranslate}} </div>
                <div *ngIf="code.commodityType=='CA'" class="small text-secondary">{{'tenders.OnlyPrice' | cxTranslate}}</div>
                <div class=" small" *ngFor="let Pricingbasis of productInfo.pricingBasis">
                    {{Pricingbasis?Pricingbasis.description:'--'}}</div>
            </div>
            <div *ngIf="(options.premiumIndex!='' && options.premiumIndex!=undefined)" class="form-group">
                <div class="small text-secondary ">{{'tenders.Premium' | cxTranslate}}</div>
                <div class=" small">
                    {{options.premiumIndex}}</div>
            </div>
    
            <div *ngIf="productInfo.defaultQuotationPeriod?.description!=''" class="form-group">
                <div id="126" *ngIf="productInfo.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                    cxTranslate}} </div>
                <div *ngIf="productInfo.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                    cxTranslate}}</div>
                <div *ngIf="productInfo.baseKOP != 'BA CU' && productInfo.baseKOP != 'BA ZN'" class="small text-secondary">
                    {{'tenders.QuotationPeriod'| cxTranslate}}</div>
            
                <select class="custom-select" [(ngModel)]="defaultValue" (change)="qpChangeAction($event)"
                    *ngIf="productInfo.isQPMultipleChoicesSelected == true">
                    <option id="{{qp.uniqueRowNumber}}" value="{{qp.description}}"
                        *ngFor="let qp of options.qpMultipleChoices; let s=index;">{{qp.description}} </option>
                </select>
                <p *ngIf="QPValuSelectedError==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.selectQPError'| cxTranslate}}</p>  
                <div class="d-flex row w-100"
                    *ngIf="(productInfo.isQuotationPeriodUnrestricted==true && options.isQPMultipleChoicesSelected== false) || (options.isQPMultipleChoicesSelected== true  && displayFixedQPSection == true && productInfo.isQuotationPeriodUnrestricted==true)">
                    <div class="form-group col-md-6 col-sm-12 mb-0">
                        <div for="Select2" class="small strong">From <span class="text-danger">*</span></div>
                        <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                            <fieldset>
                                <input [readonly]="true" [minDate]="{year: '', month: '', day: ''}" name="s"
                                    formControlName="finalQPFromDate" id="finalQPFromDate" [footerTemplate]="footerTemplate1"
                                    class="form-control bg-white  ff-normal date-width" ngbDatepicker #s="ngbDatepicker"
                                    (click)="toggle(s)" (dateSelect)="qpFromDateSelection($event)" />
                                <ng-template #footerTemplate1>
                                    <hr class="my-0">
                                    <button class="btn btn-secondary btn-sm m-2 float-end " (click)="s.close()">Close</button>
                                </ng-template>
                                <span *ngIf="isFinalQPFromDateValid" class="text-danger validity-date-error"><i
                                        class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This
                                    field
                                    is
                                    required</span>
                            </fieldset>
                            <!-- <cx-form-errors [control]="materialform.get('laycanStartDate')"></cx-form-errors> -->
                        </form>
                    </div>
                    <div class="form-group col-md-6 col-sm-12 mb-0">
                        <div for="Select3" class="small strong">To <span class="text-danger">*</span></div>
                        <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                            <fieldset>
                                <input [readonly]="true" [minDate]="{year: '', month: '', day: ''}" name="e"
                                    formControlName="finalQPToDate" id="finalQPToDate" [footerTemplate]="footerTemplate2"
                                    class="form-control bg-white  ff-normal date-width" ngbDatepicker #e="ngbDatepicker"
                                    (click)="toggle(e)" (dateSelect)="qpToDateSelection($event)" />
                                <ng-template #footerTemplate2>
                                    <hr class="my-0">
                                    <button class="btn btn-secondary btn-sm m-2 float-end " (click)="e.close()">Close</button>
                                </ng-template>
                                <span *ngIf="isFinalQPToDateValid" class="text-danger validity-date-error"><i
                                        class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This
                                    field
                                    is
                                    required</span>
                                <span *ngIf="isFinalQPToGreater" class="text-danger validity-date-error"><i
                                        class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>EndDate
                                    should
                                    be greater than startDate</span>
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div class="mt-1 small"
                    *ngIf="(productInfo.isQuotationPeriodUnrestricted==false && options.isQPMultipleChoicesSelected == false) ||  (options.isQPMultipleChoicesSelected== true  && displayFixedQPSection == true && productInfo.isQuotationPeriodUnrestricted==false)">
                    {{formatQPDates(productInfo)}}</div>
            </div>
            
           
          
            <div *ngIf="code.commodityType=='CN' && code.childList==undefined">
                
                <div class="mb-4">
                    <div class="small text-secondary ">Terms & conditions</div>
                    <div class=" small">{{code.termsAndConditions?code.termsAndConditions.description:'--'}}
                    </div>
                </div>
                <div class="mt-2" *ngIf="options.displayTCPrice == true">
                    <h6 class="strong">Enter your TC (per {{options.tcPriceUnitDesc}})</h6>
                    <span class="currency-icon position-absolute">USD &nbsp;</span>
                    <input type="text" [(ngModel)]="materialFixedPrice1" (change)="divide()" appAllowNegativeDecimalNumber
                        [beforeDecimal]="options.tcBeforeDecimals" [afterDecimal]="options.tcAfterDecimals"
                        class="form-control form-control-lg pl-5" preventCutCopyPaste required #name="ngModel" />

                    <p *ngIf="FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.enterprice'| cxTranslate}}</p>
                </div>
                <div *ngIf="options.displayRCPrice == true">
                    <h6 class="strong mt-2 ">Enter your RC (per {{options.rcPriceUnitDesc}} of payable
                        Copper)</h6>
                    <span class="currency-icon position-absolute">USD &nbsp;</span>
                    <input [(ngModel)]="materialIndexPrice1" disabled class="form-control form-control-lg pl-5" required
                        #name="ngModel" />
                </div>
            </div>
            <div *ngIf="code.commodityType!='CN'  && productInfo.childList==undefined">
                <div class="form-group">
    
                    <div *ngIf="options.displayPrice==true">
                        <h3 class="strong h6">{{getLabel(options,code.commodityType) | cxTranslate}}{{getUnit(options,code.commodityType)}}</h3>
                        <span class="currency-icon position-absolute">{{getPrefix(options,code.commodityType)}}
                            &nbsp;</span>
                        <input [(ngModel)]="priceModel" appCommonDigitsDirective [beforeDecimal]="options.beforeDecimals"
                            [afterDecimal]="options.afterDecimals" [pricingOptions]="options.pricingOptions" [commodityType]="code.commodityType" class="form-control form-control-lg pl-5"
                            preventCutCopyPaste #name="ngModel" required />
                        <p *ngIf="(FixedPriceEmpty || IndexPriceEmpty)==true" class="text-danger my-1 md-semibold-font ">Please enter your price.</p>
                    </div>
                </div>
            </div>
            
            <div class="form-group" *ngFor="let row of productInfo?.childList; let i = index;">
                
                <div *ngIf="options.pricingOptions=='FIXED_PRICE'">
                    <h6> {{row.productName}} price (per {{options.priceUnitDesc}})</h6>
                    <span class="currency-icon position-absolute" *ngIf="row.isFixedDisabled==false">USD
                        &nbsp;</span>
                    <input id="{{'cc'+i}}"  [(ngModel)]="row.FixedPrice"
                        *ngIf="row.isFixedDisabled==false" appTwoDigitDecimaNumber [beforeDecimal]="options.beforeDecimals" [afterDecimal]="options.afterDecimals"    
                         class="form-control form-control-lg pl-5" preventCutCopyPaste
                        #name="ngModel" required />
                        <p *ngIf="row.FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.enterprice'| cxTranslate}}</p>
                    <h5 class="strong" *ngIf="row.isFixedDisabled==true">USD {{row.FixedPrice}}</h5>
                </div>
                <div *ngIf="options.pricingOptions=='INDEX_PRICE'">
                    <h6> {{row.productName}} price </h6>
                    
                    <div *ngIf="options.displayPrice== true">
                       
                        <span *ngIf="code.commodityType == 'CC' && row.isIndexDisabled==false" class="currency-icon position-absolute">%
                            &nbsp;</span>
                
                        <input (mouseenter)="toolTipShow1(i)" (mouseleave)="toolTipHide1(i)" [(ngModel)]="row.IndexPrice"
                            *ngIf="row.isIndexDisabled==false" appTwoDigitDecimaNumber
                            [beforeDecimal]="options.beforeDecimals"
                            [afterDecimal]="options.afterDecimals"
                            class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" />
                        <p *ngIf="row.IndexPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                            {{'home.productHeader.enterprice'| cxTranslate}}</p>
                        <div *ngIf="isHidden1 && code.commodityType == 'CC' && row.isIndexDisabled==false">
                            <span class="tooltip_msg" id="differential_values1{{i}}">enter your price e.g. 97.5% or 102.5%
                            </span>
                        </div>
                        <h5 class="strong" *ngIf="row.isIndexDisabled==true">{{row.IndexPrice}} %</h5>
                    </div>
                </div>
            </div>

    
        </div>
    </div>
 

    <div *ngIf="productInfo?.pricingOptionsEnum?.length>1 && code.commodityType != 'CN'">
        <!--  Displaying pricing option if tendertype !lumpfixed or tendertype = fixedlp and productcode !=nbll-->
        <div class="d-flex justify-content-between mt-2 mb-4">
            <div class="small w-100">
                <h6 class="strong">{{'tenders.SelectPricingOption' | cxTranslate}} </h6>
                <div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
                    <label *ngFor="let row of productInfo?.pricingOptionsEnum;let r=index;" 
                        [ngClass]="getClass(productInfo.pricingOptionsEnum.length)" (click)="changeTab(row.pricingOptions)"
                        id="{{row.pricingOptions}}">
                        <input type="radio" name="options" id="option1" class="h6">{{row.pricingOptionsValue}}</label>
                </div>
            </div>
        </div>
        <div *ngIf="priceTab=='FIXED_PRICE'">
            <div class="form-group" *ngIf="code.commodityType == 'IO' && productInfo?.childList==undefined">
                <h6 id="d" class="strong">{{'tenders.Enteryourprice'|cxTranslate}} (per
                    {{productInfo?.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</h6>
                <span class="currency-icon position-absolute">USD &nbsp;</span>
                <input [(ngModel)]="materialFixedPrice1" appTwoDigitDecimaNumber
                    [beforeDecimal]="productInfo.displayFixedPriceConfig.displayFixedPriceBeforeDecimals"
                    [afterDecimal]="productInfo.displayFixedPriceConfig.displayFixedPriceAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                <p *ngIf="FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                    {{'home.productHeader.enterprice'| cxTranslate}}</p>
            </div>
            <div>
                <div class="form-group" *ngFor="let row of productInfo?.childList">
                    <h6 id="CoalRow"> {{row.productName}} price (per
                        {{row.displayFixedPriceConfig?.displayFixedPriceUnitDesc}})</h6>
                    <div *ngIf=" row.displayIndexPriceConfig?.displayIndexPrice== true">
                        <span class="currency-icon position-absolute" *ngIf="row.isFixedDisabled==false">USD
                            &nbsp;</span>
                        <input id="ccindex" [(ngModel)]="row.FixedPrice" *ngIf="row.isFixedDisabled==false"
                            appTwoDigitDecimaNumber
                            [beforeDecimal]="row.displayFixedPriceConfig?.displayFixedPriceBeforeDecimals"
                            [afterDecimal]="productInfo.displayFixedPriceConfig.displayFixedPriceAfterDecimals"
                            class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                        <p *ngIf="row.FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                            {{'home.productHeader.enterprice'| cxTranslate}}</p>
                        <h5 class="strong" *ngIf="row.isFixedDisabled==true">USD {{row.FixedPrice}}</h5>
                    </div>
                </div>

            </div>
            <!--Coal specific-->
            <div class="form-group" *ngIf="code.commodityType == 'CC' && productInfo?.childList==undefined">
                <h6 *ngIf="fixedPriceDisabled==false" class="strong">{{'tenders.Enteryourprice'|cxTranslate}}
                    (per {{productInfo?.displayFixedPriceConfig.displayFixedPriceUnitDesc}} )</h6>
                <h6 *ngIf="fixedPriceDisabled==true" class="strong">{{'tenders.YourPrice(perDMT)'|cxTranslate}}
                    (per {{productInfo?.displayFixedPriceConfig.displayFixedPriceUnitDesc}} )</h6>
                <span class="currency-icon position-absolute" *ngIf="fixedPriceDisabled==false">USD &nbsp;</span>
                <input id="fixedinpcc" [(ngModel)]="materialFixedPrice1" *ngIf="fixedPriceDisabled==false"
                    appTwoDigitDecimaNumber
                    [beforeDecimal]="productInfo.displayFixedPriceConfig.displayFixedPriceBeforeDecimals"
                    [afterDecimal]="productInfo.displayFixedPriceConfig.displayFixedPriceAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                <p *ngIf="FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                    {{'home.productHeader.enterprice'| cxTranslate}}</p>
                <h5 id="fixheadcc" class="strong" *ngIf="fixedPriceDisabled==true">{{materialFixedPrice1}}</h5>
            </div>
            <hr>
            
            <span class="text-danger fs-10 " *ngIf='productInfo && productInfo.priceValue == 0 '>{{
                'home.productHeader.priceisincorrect' | cxTranslate }}</span>
        </div>
        <div *ngIf="(priceTab!='FIXED_PRICE' && priceTab!='none')">
            <div class="form-group">
                <div *ngIf="code.commodityType!='CA'" class="small text-secondary">{{'tenders.Pricingbasis' | cxTranslate}} </div>
                <div *ngIf="code.commodityType=='CA'" class="small text-secondary">{{'tenders.OnlyPrice' | cxTranslate}}</div>
                <!-- <div class=" small">{{productInfo.pricingBasis?productInfo.pricingBasis[0].description:'--'}} </div> -->
                <div class="small" *ngFor="let pricingBasis of productInfo.pricingBasis">
                    {{getPricingBasisBasedOnOption(priceTab,pricingBasis.description)}}</div>
            </div>
            <div class="form-group"  *ngIf="priceTab=='FLOATING_PREMIUM'" >
                <div class="small text-secondary"  >{{'tenders.Premium' | cxTranslate}}</div>
                <div class="small" *ngFor="let price of productInfo.pricingOptionsEnum">{{getPremiumIndex(price.premiumIndex)}}</div>
            </div>
            <!-- <div *ngIf="priceTab=='FLOATING_PREMIUM'">
                <div *ngIf="productInfo.pricingOptionsEnum[1].premiumIndex">
                    <div class="mt-2 small text-secondary">Premium</div>
                    <div class="small text-black">
                        {{productInfo.pricingOptionsEnum[1].premiumIndex}}
                </div>

            </div>
         </div> -->
            <div class="form-group">
                <div class="small text-secondary">{{'tenders.QuotationPeriod'| cxTranslate}}</div>
               
            <!-- <div class="mt-2" *ngIf="code.commodityType == 'IO' || code.commodityType == 'CC'">
                <h3 *ngIf="code.commodityType == 'CC'" class="strong h6">{{'tenders.PremiumDiscount'|cxTranslate}}</h3>
                <h3 *ngIf="code.commodityType == 'IO'" class="strong h6">{{'tenders.Enteryourprice'|cxTranslate}} (per{{productInfo?.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</h3>
                <span *ngIf="code.commodityType == 'CC'" class=" currency-icon position-absolute semibold ml-2 mt-2">% &nbsp;</span>
                <span *ngIf="code.commodityType == 'IO'" class=" currency-icon position-absolute semibold ml-2 mt-2">$ &nbsp;</span>
                <input  (mouseenter)="toolTipSho()" (mouseleave)="toolTipHid()" [(ngModel)]="materialIndexPrice1" 
                    
                    class="form-control small strong pl-5" preventCutCopyPaste #name="ngModel" required />
                    <div *ngIf="isHidde && code.commodityType == 'CC'">
                    <span class="tooltip_msg" id="differential_value">enter your price e.g. 97.5% or 102.5%
                        </span>
                    </div>
                <p *ngIf="materialIndexPrice1<0" class="text-danger my-1 md-semibold-font "> Place bid $0.00 or
                    higher.</p>
            </div> -->
            <select class="custom-select" [(ngModel)]="defaultValue" (change)="qpChangeAction($event,i)" *ngIf=" productInfo.isQPMultipleChoicesSelected == true">
                <option id="{{qp.uniqueRowNumber}}" value="{{qp.description}}" *ngFor="let qp of productInfo.qpMultipleChoices; let i=index;">{{qp.description}}  </option>    
            </select>
            <p *ngIf="QPValuSelectedError==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.selectQPError'| cxTranslate}}</p>  
            <div class="d-flex row w-100" *ngIf="(productInfo.isQuotationPeriodUnrestricted==true) ||(productInfo.isQPMultipleChoicesSelected== true && displayFixedQPSection == true && productInfo.isQuotationPeriodUnrestricted == true)">
                <div class="form-group col-md-6 col-sm-12 mb-0">
                    <div for="Select2" class="small strong">From <span class="text-danger">*</span></div>
                    <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                        <fieldset>
                            <input [readonly]="true" name="s" formControlName="finalQPFromDate" id="finalQPFromDate"
                                [footerTemplate]="footerTemplate1" [minDate]="{year: '', month: '', day: ''}"
                                class="form-control bg-white  ff-normal date-width" ngbDatepicker #s="ngbDatepicker"
                                (click)="toggle(s)" (dateSelect)="qpFromDateSelection($event)" />
                            <ng-template #footerTemplate1>
                                <hr class="my-0">
                                <button class="btn btn-secondary btn-sm m-2 float-end " (click)="s.close()">{{
                                    'home.quote.Close' | cxTranslate }}</button>
                            </ng-template>
                            <span *ngIf="isFinalQPFromDateValid" class="validity-date-error text-danger"><i
                                    class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This field is
                                required</span>
                        </fieldset>
                    </form>
                </div>
                <div class="form-group col-md-6 col-sm-12 mb-0">
                    <div for="Select3" class="small strong">To <span class="text-danger">*</span></div>
                    <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                        <fieldset>
                            <input [readonly]="true" name="e" formControlName="finalQPToDate" id="finalQPToDate"
                                [footerTemplate]="footerTemplate2" [minDate]="{year: '', month: '', day: ''}"
                                class="form-control bg-white  ff-normal date-width" ngbDatepicker #e="ngbDatepicker"
                                (click)="toggle(e)" (dateSelect)="qpToDateSelection($event)" />
                            <ng-template #footerTemplate2>
                                <hr class="my-0">
                                <button class="btn btn-secondary btn-sm m-2 float-end " (click)="e.close()">{{
                                    'home.quote.Close' | cxTranslate }}</button>
                            </ng-template>
                            <span *ngIf="isFinalQPToDateValid" class="text-danger validity-date-error"><i
                                    class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This field is
                                required</span>
                            <span *ngIf="isFinalQPToGreater" class="text-danger validity-date-error"><i
                                    class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>EndDate should
                                be greater than startDate</span>
                        </fieldset>
                    </form>
                </div>
            </div>
            <div class="small" *ngIf="(productInfo.isQuotationPeriodUnrestricted == false && productInfo.isQPMultipleChoicesSelected == false) || (productInfo.isQuotationPeriodUnrestricted==false && productInfo.isQPMultipleChoicesSelected== true && displayFixedQPSection == true)">
                {{formatQPDates(productInfo)}}</div>
                            </div>

            <!--Iron ore-->
            <div *ngIf="(code.commodityType == 'IO' || code.commodityType == 'CA')  && productInfo?.childList==undefined && priceTab!='FLOATING_PREMIUM'&&
                (productInfo?.displayIndexPriceConfig.displayIndexPrice==true || 
                 productInfo?.displayFixedPremiumConfig.displayFixedPremium ||
                 productInfo?.displayLumpFixedPriceConfig.displayLumpFixedPrice) "
                class="form-group">
                <!-- <h3 class="strong h6">{{'tenders.PremiumDiscount'|cxTranslate}}</h3> -->
                <h3 *ngIf="priceTab=='INDEX_PRICE'" class="strong h6">{{'tenders.PremiumDiscount'|cxTranslate}} (per
                    {{productInfo?.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</h3>
                <h3 *ngIf="priceTab=='LUMP_FIXED_PRICE'" class="strong h6">{{'tenders.PremiumDiscount'|cxTranslate}}
                    (per {{productInfo?.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</h3>
                    <h3 *ngIf="priceTab=='FIXED_PREMIUM'" class="strong h6">{{'tenders.PremiumDiscount'|cxTranslate}}
                        (per {{productInfo?.displayFixedPremiumConfig.displayFixedPremiumUnitDesc}})</h3>
                <span class="currency-icon position-absolute">USD &nbsp;</span>
                <input *ngIf="priceTab=='INDEX_PRICE'" [(ngModel)]="materialIndexPrice1" appAllowNegativeDecimalNumber
                    [beforeDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceBeforeDecimals"
                    [afterDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                <input *ngIf="priceTab=='LUMP_FIXED_PRICE'" [(ngModel)]="materialIndexPrice1"
                    appAllowNegativeDecimalNumber
                    [beforeDecimal]="productInfo.displayLumpFixedPriceConfig.displayLumpFixedPriceBeforeDecimals"
                    [afterDecimal]="productInfo.displayLumpFixedPriceConfig.displayLumpFixedPriceAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                    <input *ngIf="priceTab=='FIXED_PREMIUM'" [(ngModel)]="materialIndexPrice1"
                    appAllowNegativeDecimalNumber
                    [beforeDecimal]="productInfo.displayFixedPremiumConfig.displayFixedPremiumBeforeDecimals"
                    [afterDecimal]="productInfo.displayFixedPremiumConfig.displayFixedPremiumAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                <p *ngIf="IndexPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                    {{'home.productHeader.enterprice'| cxTranslate}}</p>
            </div>
            <div *ngIf="code.commodityType == 'IO'">
                <div class="form-group" *ngFor="let row of productInfo?.childList">
                    <h6 *ngIf="priceTab=='INDEX_PRICE'"> {{row.productName}} price (per
                        {{productInfo?.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</h6>
                    <h6 *ngIf="priceTab=='LUMP_FIXED_PRICE'"> {{row.productName}} price (per
                        {{productInfo?.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</h6>
                    <span class="currency-icon position-absolute" *ngIf="isDisabled==false">USD
                        &nbsp;</span>
                    <input [(ngModel)]="row.materialIndexPrice1" *ngIf="isDisabled==false" appTwoDigitDecimaNumber
                        [beforeDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceBeforeDecimals"
                        [afterDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceAfterDecimals"
                        class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" required />
                    <p *ngIf="IndexPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                        {{'home.productHeader.enterprice'| cxTranslate}}</p>
                    <h5 class="strong" *ngIf="isDisabled==true">{{row.materialIndexPrice1}}</h5>
                </div>

            </div>
            <!--coal specific-->
            <div class="form-group" *ngIf="code.commodityType == 'CC'&& productInfo?.childList==undefined" class="my-3">
                <h6 *ngIf="indexPriceDisabled==false" class="strong">{{'tenders.enterPrice'|cxTranslate}}</h6>
                <h6 *ngIf="indexPriceDisabled==true" class="strong">{{'tenders.YourPrice(perDMT)'|cxTranslate}}</h6>
                <span class="currency-icon position-absolute" *ngIf="indexPriceDisabled==false">% &nbsp;</span>
                <input id="ccinput" (mouseenter)="toolTipShow2()" (mouseleave)="toolTipHide2()"
                    [(ngModel)]="materialIndexPrice1" *ngIf="indexPriceDisabled==false" appTwoDigitDecimaNumber
                    [beforeDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceBeforeDecimals"
                    [afterDecimal]="productInfo.displayIndexPriceConfig.displayIndexPriceAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" />
                <span *ngIf="isHidden2" class="tooltip_msg" id="differential_values3">enter your price e.g. 97.5% or
                    102.5%
                </span>
                <h5 id="headingcc" class="strong" *ngIf="indexPriceDisabled==true">{{materialIndexPrice1}}</h5>
                <p *ngIf="IndexPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                    {{'home.productHeader.enterprice'| cxTranslate}}</p>
            </div>
            <div *ngIf="code.commodityType == 'CC'">
                <div class="form-group" *ngFor="let row of productInfo?.childList; let i = index;">
                    <h6> {{row.productName}} price</h6>
                    <div *ngIf=" row.displayIndexPriceConfig?.displayIndexPrice== true">
                        <span class="currency-icon position-absolute" *ngIf="row.isIndexDisabled==false">%
                            &nbsp;</span>
                        <input (mouseenter)="toolTipShow3(i)" (mouseleave)="toolTipHide3(i)"
                            [(ngModel)]="row.IndexPrice" *ngIf="row.isIndexDisabled==false" appTwoDigitDecimaNumber
                            [beforeDecimal]="row.displayIndexPriceConfig?.displayIndexPriceBeforeDecimals"
                            [afterDecimal]="row.displayIndexPriceConfig?.displayIndexPriceAfterDecimals"
                            class="form-control form-control-lg pl-5" preventCutCopyPaste #name="ngModel" />
                        <h5 class="strong" *ngIf="row.isIndexDisabled==true">{{row.IndexPrice}} %</h5>
                        <span *ngIf="isHidden3 && row.isIndexDisabled==false" class="tooltip_msg"
                            id="differential_values3{{i}}">enter
                            your price e.g. 97.5% or 102.5%
                        </span>
                        <p *ngIf="row.IndexPriceEmpty==true" class="text-danger my-1 md-semibold-font ">
                            {{'home.productHeader.enterprice'| cxTranslate}}</p>
                        <!-- <h5 class="strong" *ngIf="row.isDisabled==true">{{row.price}}</h5> -->
                    </div>
                </div>

            </div>
            <hr>
            
        </div>
    </div>
    

</div>
<div class="modal-footer bg-light" >
    <div class="w-100 form-group mb-0">
        <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="Openmodal()">
            Next
        </button>
        <div class="d-flex justify-content-between mt-2">
            <button class="btn btn-lg btn-light button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                cxTranslate}}</button>
            <button class="btn btn-lg btn-light button" type="button" (click)="ActiveModal.dismiss('close click');"
                data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
        </div>
    </div>
</div>